<template>
    <div class="page-body">
        <div class="page-content">
            <div class="page-left-nav">
                <ComLeftNav />
            </div>
            <div class="page-right main-body">
                <div class="info-box">
                    <h3 class="info-title">{{ info.title }}</h3>
                    <div class="info-params">
                        <div class="param-item">序号：{{info.article_id  }}</div>
                        <div class="param-item">年代：{{info.year  }}</div>
                        <div class="param-item">作者：{{info.author  }}</div>
                        <div class="param-item">分类：{{info.category.category_name  }}</div>
                    </div>
                </div>
                <div v-if="info.content_type == 'video'">
                    <div class="video-item" v-for="(item,index) in info.extra_files" :key="index">
                        <video width="620" controls>
                            <source :src="item.url" type="video/mp4">
                        </video>
                        <div class="file-name">文件名：{{ item.name }}</div>
                    </div>
                </div>
                <div v-else-if="info.content_type == 'image'">
                    <div class="carousel-box">
                        <a-carousel arrows dots-class="slick-dots slick-thumb">
                            <template #customPaging="props">
                                <a>
                                    <img :src="info.extra_files[props.i].url" class="carousel-box-item" />
                                </a>
                            </template>
                            <div v-for="(item,index) in info.extra_files" :key="index">
                                <img :src="item.url" />
                            </div>
                        </a-carousel>
                    </div>
                </div>
                <div v-else-if="info.content_type == 'article'">
                    <div class="article-item" v-for="(item,index) in info.extra_files" :key="index">
                        <p>文件名：{{ item.name }}</p>
                    </div>
                    <div class="article-content" v-html="info.content "></div>
                </div>
                <div v-else-if="info.content_type == 'audio'">
                    <div class="audio-item" v-for="(item,index) in info.extra_files" :key="index">
                        <audio controls>
                            <source :src="item.url" type="audio/mpeg">
                            您的浏览器不支持 audio 元素。
                        </audio>
                        <div class="file-name">文件名：{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        defineComponent,
        onMounted,
        reactive
    } from "vue";

    import {
        useRoute,
    } from "vue-router";

    import ComLeftNav from "./ComLeftNav.vue";
    import * as Api from "@/views/resource/api";
    const baseUrl = 'https://raw.githubusercontent.com/vueComponent/ant-design-vue/main/components/carousel/demo/';
    export default defineComponent({
        components: {
            ComLeftNav,
        },
        setup() {
            const route = useRoute();

            const article_id = parseInt(route.query.id ? route.query.id : 0);
            // console.log(article_id)

            const info = reactive({
                article_id: 0,
                title: '',
                year: '',
                author: '',
                category: {},
                content_type: '',
                content: '',
                extra_files: []
            });

            // 初始化
            onMounted(() => {
                Api.getArticleDetail({
                    article_id: article_id
                }).then((res) => {
                    if (res.status == 200) {
                        info.article_id = res.data.article_id;
                        info.title = res.data.title;
                        info.year = res.data.year;
                        info.author = res.data.author;
                        info.category = res.data.category;
                        info.content_type = res.data.content_type;
                        info.content = res.data.content;
                        info.extra_files = res.data.extra_files;

                    }
                });
            });

            const getImgUrl = i => {
                return `${baseUrl}abstract0${i + 1}.jpg`;
            };

            return {
                getImgUrl,
                info
            };
        },
    });
</script>

<style scoped lang="less">
    .page-body {
        padding-top: 120px;
        background-color: #ECECEC;
        min-height: 100vh;

        .page-content {
            width: 80%;
            margin: 0 10%;
            display: flex;

            .page-left-nav {
                width: 340px;

                .nav-top {
                    font-size: 24px;
                    color: #fff;
                    background-color: #CB5520;
                    line-height: 70px;
                    text-align: center;
                }

                .nav-content {
                    .nav-list-box {
                        min-height: 600px;
                        background: url('~@/assets/img/s_2.png') no-repeat center;
                        padding-top: 50px;

                        .nav-list-item {
                            cursor: pointer;
                            width: 220px;
                            line-height: 56px;
                            text-align: center;
                            height: 56px;
                            font-size: 18px;
                            margin: 0 auto;
                            color: #333;
                            margin-bottom: 10px;
                        }

                        .active {
                            background: url('~@/assets/img/s_title.png') no-repeat center;
                        }
                    }
                }
            }

            .page-right {
                flex: 1;
                margin-left: 20px;
                background-color: #ffffff;
                padding: 20px;

                .info-box {
                    .info-title {
                        text-align: center;
                        font-weight: bold;
                    }

                    .info-params {
                        display: flex;
                        justify-content: space-between;
                        margin: 20px 0;
                        padding: 20px;
                        border-top: 1px dashed #9a2929;
                        border-bottom: 1px dashed #9a2929;

                        .param-item {
                            font-size: 14px;
                            color: #333;
                        }
                    }
                }

                .video-item {
                    margin-bottom: 20px;
                    text-align: center;

                    .file-name {
                        margin-bottom: 20px;
                    }
                }

                .image-item {
                    margin-bottom: 20px;
                    text-align: center;

                    .image-item-img {
                        max-width: 600px;
                    }
                }

                .article-item {
                    margin-bottom: 20px;
                    text-align: left;
                }

                .audio-item {
                    margin-bottom: 20px;
                    text-align: center;

                    .file-name {
                        margin-bottom: 20px;
                    }
                }
            }
        }
    }

    .carousel-box{
        max-width: calc(~"80vw - 380px");
        text-align: center;
    }
    .carousel-box-item{
        max-height: 400px;
    }

    /* For demo */
    :deep(.slick-dots) {
        position: relative;
        height: auto;
    }

    :deep(.slick-slide img) {
        border: 5px solid #fff;
        display: block;
        margin: auto;
        max-width: 80%;
        max-height: 400px;
    }

    :deep(.slick-arrow) {
        display: none !important;
    }

    :deep(.slick-thumb) {
        bottom: 0px;
    }

    :deep(.slick-thumb li) {
        width: 60px;
        height: 45px;
    }

    :deep(.slick-thumb li img) {
        width: 100%;
        height: 100%;
        filter: grayscale(100%);
        display: block;
    }

    :deep .slick-thumb li.slick-active img {
        filter: grayscale(0%);
    }
</style>